<template>
  <v-card class="pa-3 ma-0">
    <v-layout row align-center justify-space-between>
      <h2>Mass add Allergens</h2>
      <v-btn
        flat
        fab
        small
        type="button"
        class="ma-0"
        data-dismiss="modal"
        @click="$emit('close')"
        aria-label="Close">
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-alert :value="true" type="error" v-if="err">
      {{err}}
    </v-alert>
    <div>
      <v-layout row wrap align-center class="checkbox-wrap my-4">
        <v-checkbox
          v-for="(allergen, index) in catalogAllergens"
          :key="index"
          color="primary"
          v-model="allergen.selected"
          @change="$forceUpdate()"
          :label="allergen.name[language]">
        </v-checkbox>
      </v-layout>
      <v-layout row justify-end>
        <v-btn color="primary" class="mx-0" @click="submitAllergens()">Submit</v-btn>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
  export default {
    props: ['allergens'],
    data() {
      return {
        language: this.$cookie.get('lang') || 'en',
        catalogAllergens: [],
        err: '',
      };
    },
    methods: {
      submitAllergens() {
        const allergens = [];
        this.catalogAllergens.forEach((allergen, index) => {
          if (allergen.selected) {
            allergens.push(allergen.allergenId);
          }
        });
        this.$emit('submit', allergens);
      },
    },
    created() {
      this.catalogAllergens = this.allergens.map((current) => {
        const allergen = current;
        allergen.selected = false;
        return allergen;
      });
    }
  };
</script>

<style lang="scss">

  .checkbox-wrap {
    width: 100%;
    .input-group {
      min-width: 140px;
      flex: none;
      width: auto;
      width: fit-content;
      padding: 0 32px;
      .input-group__details {
        display: none !important;
      }
      label {
        position: relative !important;
        left: 0;
        max-width: 220px;
        width: auto;
        width: fit-content;
        overflow: hidden;
      }
      .input-group__input {
        position: absolute;
        left: 0;
        top: 0;
        width: 32px;
        flex: 0;
      }
      --selection-controls {
        display: inline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MassAllergensAddModal.vue?4969faaa